import { Grid2, Typography } from "@mui/material"

export default function ScheduleContainer(){


    return (
        <Grid2>
            <Typography>Schedule Mode</Typography>
        </Grid2>
    )
}